var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var Mapping = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat(['mapping(', path.call(_print, 'keyType'), ' => ', path.call(_print, 'valueType'), ')']);
  }
};
module.exports = Mapping;